import { render, staticRenderFns } from "./basicTextarea.vue?vue&type=template&id=8696b864&scoped=true&"
import script from "./basicTextarea.vue?vue&type=script&lang=js&"
export * from "./basicTextarea.vue?vue&type=script&lang=js&"
import style0 from "./basicTextarea.vue?vue&type=style&index=0&id=8696b864&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8696b864",
  null
  
)

export default component.exports